import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=221a5cc9&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"
import style0 from "./Testimonial.vue?vue&type=style&index=0&id=221a5cc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a5cc9",
  null
  
)

export default component.exports